import { Flex, Box } from '@chakra-ui/react';
import { UserActivityTable } from './user-activity-table';
import { GroupBy } from '../../../../shared/group-by';
import { BreakdownBy } from '../../../../shared/breakdown-by';
import { setFilter } from '@/store/reports/filter';
import { useDispatch } from 'react-redux';
import { useContext } from 'react';
import { ReportSelectionContext } from '@/contextProviders/ReportSelection';
import { useKFlags } from '@/hooks/use-k-flags';
import { EmptyDataWrapper } from '@/pages/reports/ats-reports/components/empty-data-wrapper';

export const Table = ({
  data = [],
  filters = {},
  isReadOnly = false,
  isPrintView = false,
  customData = undefined,
  renderTitle = undefined,
  customBreakdownChange = undefined,
  filterParams = undefined,
  hideLinks = undefined,
  isFullScreen = false,
  tile = {},
  isStaticReport = false,
  onSortChange = (_sortState) => {},
  onTableColDataChange = undefined,
  initialTableColData = undefined,
  skipLocalStorage = false,
  tableColStyles = {},
  isEditMode = false,
}) => {
  const dispatch = useDispatch();
  const { consumer } = useContext(ReportSelectionContext);
  const { ats_enabled } = useKFlags();

  const onChangeBreakDown = (selected) => {
    dispatch(
      setFilter({
        type: ats_enabled ? 'user_activity_break_down' : 'break_down',
        value: selected?.id,
      })
    );
  };

  const onChangeGroupBy = (selected) => {
    dispatch(
      setFilter({
        type: ats_enabled ? 'user_activity_group_by' : 'group_by',
        value: selected?.id,
      })
    );
  };

  const breakDown = ats_enabled
    ? filters?.user_activity_break_down
    : filters.break_down;

  const groupBy = ats_enabled
    ? filters?.user_activity_group_by
    : filters.group_by;

  const metricFields = [
    'added',
    'sent_first',
    'sent_followup',
    'replied',
    'interested',
  ];
  const getFieldWithData = () => {
    const dataToUse = customData || data;
    if (!dataToUse?.length) return 'added';
    for (const field of metricFields) {
      if (dataToUse.some((row) => row[field] > 0)) return field;
    }
    return 'added';
  };

  return (
    <Box h="calc(100% - 35px)">
      {consumer === 'DEFAULT' && (
        <Flex
          justifyContent={renderTitle ? 'space-between' : 'end'}
          w="100%"
          position="sticky"
          top="0"
          zIndex="6"
          bg="white"
        >
          {renderTitle && renderTitle?.()}
          <Flex
            gap="8px"
            mt={!customData && '20px'}
            position="relative"
            zIndex="99"
            flexDir="row-reverse"
            flexShrink={0}
            mr={isPrintView ? '0' : isEditMode ? '55px' : '35px'}
            mb="12px"
          >
            <BreakdownBy
              isPortal={!isFullScreen}
              isEditMode={isEditMode}
              selected={breakDown}
              onChange={(option) =>
                customBreakdownChange
                  ? customBreakdownChange('group_by_2', option)
                  : onChangeBreakDown(option)
              }
            />
            <GroupBy
              isEditMode={isEditMode}
              isPortal={!isFullScreen}
              selected={groupBy}
              onChange={(option) =>
                customBreakdownChange
                  ? customBreakdownChange('group_by_1', option)
                  : onChangeGroupBy(option)
              }
            />
          </Flex>
        </Flex>
      )}
      <EmptyDataWrapper data={customData || data} field={getFieldWithData()}>
        <UserActivityTable
          isReadOnly={isReadOnly}
          filters={filters}
          data={customData || data}
          filterParams={filterParams}
          hideLinks={hideLinks}
          isFullScreen={isFullScreen}
          isStaticReport={isStaticReport}
          tile={tile}
          onSortChange={onSortChange}
          onTableColDataChange={onTableColDataChange}
          initialTableColData={initialTableColData}
          skipLocalStorage={skipLocalStorage}
          tableColStyles={tableColStyles}
          isEditMode={isEditMode}
        />
      </EmptyDataWrapper>
    </Box>
  );
};
